import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { IApiResponse, IFetchReconciliation } from "@/services/reconciliation/reconciliation.type";

export interface ReconciliationState {
  reconciliation : IApiResponse;
  loading: boolean;
  error: boolean;
}

export const initialState: ReconciliationState = {
  reconciliation: {
    data: [],
    pagination: {
      totalRecords: 0,
      currentPage: 0,
      totalPages: 0,
      nextPage: 0,
      previousPage: 0,
    },
    success: false,
    message: "",
  },
  loading: false,
  error: false,
};

const reconciliationSlice = createSlice({
  name: "reconciliation",
  initialState,
  reducers: {
    getReconciliations: (state, action: PayloadAction<IFetchReconciliation>) => {
      state.loading = true;
    },
    getReconciliationsSuccess: (state, action: PayloadAction<IApiResponse>) => {
      state.loading = false;
      state.reconciliation = { ...action.payload };
    },
    getReconciliationsFailure: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.error = true;
      state.reconciliation = {...initialState?.reconciliation} ;
    },
  },
});

const reconciliationReducer = reconciliationSlice.reducer;

export const { getReconciliations, getReconciliationsSuccess, getReconciliationsFailure } =
reconciliationSlice.actions;

export default reconciliationReducer;
